import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { IconComponent } from './icon.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, AngularSvgIconModule],
  declarations: [IconComponent],
  exports: [IconComponent],
})
export class IconModule {}
